/**
 * @description
 * Применяет функции к аргументу и возвращает первый не нулевой результат
 *
 * @example
 * const getErrorMessage = firstOf<ServerError, string>(
 *   get('body.message'),
 *   get('body.code'),
 *   get('message'),
 *   constant('🤷‍ Зовите фиксиков!'),
 * )
 * getErrorMessage({
 *   body: {
 *     message: 'some message',
 *     code: 'error code'
 *   }
 * }) // some message
 */
export const firstOf = <TArgument, TResult>(...fns: ((arg: TArgument) => TResult | undefined)[]) => {
  return (arg: TArgument): TResult | undefined => {
    for (let i = 0, len = fns.length; i < len; i += 1) {
      const fn = fns[i]
      const result = fn && fn(arg)

      if (result !== undefined) {
        return result
      }
    }
  }
}
